export type BusinessNatureName = 'BusinessOwner' | 'Customer';
export const BusinessNatureName = {
  ABO: 'BusinessOwner' as BusinessNatureName,
  Customer: 'Customer' as BusinessNatureName
};
